import { render, staticRenderFns } from "./FrData.vue?vue&type=template&id=7273e57c&scoped=true"
import script from "./FrData.vue?vue&type=script&lang=js"
export * from "./FrData.vue?vue&type=script&lang=js"
import style0 from "./FrData.vue?vue&type=style&index=0&id=7273e57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273e57c",
  null
  
)

export default component.exports